<script setup>
import { useAccount } from 'dashboard/composables/useAccount';
import ContactsIndex from './ContactsIndex.vue';
import ContactsPortfolio from './ContactsPortfolio.vue';

const { currentAccount } = useAccount();
</script>

<template>
  <ContactsPortfolio
    v-if="currentAccount?.settings?.contacts_portfolio_enabled === true"
  />
  <ContactsIndex v-else />
</template>
